import { useDispatch } from 'react-redux';
import { setEvidenceNotes } from '../../../../../../features/actuarial/annual-premium-eoi.slice';
import {  EditIconSVG } from '../../../../../../assets/icon/svg';
import RichTextViewer from '../../../../../../library/ckeditor/rich-text-viewer';
import { useComputationActions } from '../../../../../../hooks/actions/user-computation-actions';
import CKEditor from '../../../../../../library/ckeditor/ck-editor';
import { useProposalComputation } from '../../../../../../hooks/proposal/use-proposal-computation';

interface Props {
    customStyle?: string;
}

export default function EvidenceOfInsurability({ customStyle = 'grid-cols-2' }: Props) {

    const dispatch = useDispatch();
    const { evidenceNotes, isEvidenceOfInsurability } = useProposalComputation()
    const { 
        cantEdit, 
        handleSaveEvidence, 
        handleCancelUpdateEvidence, 
        handleIsUpdateEvidence,
        isLoadingEvidenceNotes
    } = useComputationActions()

    return (
        <div className={`col-span-1 rounded ${customStyle}`}>
            <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                <div className="flex items-center justify-between gap-3 border-b border-gray-200 bg-gray-50 px-3 py-3 sm:px-4">
                    <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2">
                            <span className="h-2 w-2 shrink-0 rounded-full bg-[#186cb2]" />
                            <h3 className="truncate text-xs font-semibold text-gray-800">
                                Evidence of Insurability
                            </h3>
                        </div>
                        <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                            Specify the medical requirements and underwriting notes for this proposal.
                        </p>
                    </div>
                    <button
                        type="button"
                        disabled={cantEdit || isLoadingEvidenceNotes}
                        onClick={handleIsUpdateEvidence}
                        className="flex size-9 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-white text-[#186cb2] transition-colors hover:bg-[#186cb2]/5 disabled:cursor-not-allowed disabled:opacity-50 sm:h-auto sm:w-auto sm:gap-1.5 sm:px-3 sm:py-1.5"
                    >
                        <EditIconSVG size={14} />
                        <span className="hidden sm:inline text-xs">Edit Amount</span>
                    </button>
                </div>
                <div className="p-3">
                    <RichTextViewer value={evidenceNotes} />
                </div>
            </div>
            <CKEditor
                isOpen={isEvidenceOfInsurability}
                title={'evidence of insurability'}
                value={evidenceNotes}
                onChange={(e) => dispatch(setEvidenceNotes(e))}
                onClose={handleCancelUpdateEvidence}
                onSave={handleSaveEvidence}
                isLoading={isLoadingEvidenceNotes}
            />
        </div>
    );
}